import Header from "../Components/Header/header";
import Project from "../Components/Project/Project";

import { projects } from "../helpers/projectList";

const ProjectPortfolio = () => {
    return (
        <>
        <Header />

      <main className="section">
        <div className="container">
          <h2 className="title-1">Projects</h2>
          <ul className="projects">

            {projects.map((el, index) => {
              return (
                <Project key={index} title={el.title} img={el.img} index={index}/>
              )
            })}

          </ul>
        </div>
      </main>
      </>
    )
}

export default ProjectPortfolio;